/*
  La galleria del corpo. Nessuna libreria.
  Sul telefono un carosello a scatti con i puntini; dai 64rem una lastra
  grande a destra e la colonna di miniature a sinistra, anche con le
  frecce. Ogni lastra si apre a piena finestra in un dialog: Esc, lo sfondo
  e Chiudi lo chiudono, il fuoco resta dentro e torna a chi lo aveva. Con
  meno movimento i video restano fermi. Ogni testo visibile arriva dal
  Liquid.
*/

(function () {
  'use strict';

  var galleria = document.querySelector('[data-galleria]');
  if (!galleria) return;

  var lastre = galleria.querySelector('[data-galleria-lastre]');
  var figure = lastre ? lastre.querySelectorAll('[data-galleria-lastra]') : [];
  var contatore = galleria.querySelector('[data-galleria-contatore]');
  var punti = galleria.querySelectorAll('[data-galleria-punto]');
  var miniature = galleria.querySelectorAll('[data-galleria-vai]');
  var modello = contatore ? contatore.getAttribute('data-modello') || '@n / @tot' : '';
  var ridotto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inAttesa = false;

  galleria.classList.add('galleria--pronta');

  if (ridotto) {
    var video = galleria.querySelectorAll('video');
    for (var v = 0; v < video.length; v++) {
      video[v].removeAttribute('autoplay');
      video[v].pause();
    }
  }

  /* Segna la posizione corrente sul contatore per lo schermo (sr-only) e sui puntini. */
  function segnaPosizione(indice) {
    var vistePunti = visibili(punti);
    if (contatore) {
      contatore.textContent = modello.replace('@n', String(indice + 1)).replace('@tot', String(visibili(figure).length));
    }
    for (var p = 0; p < vistePunti.length; p++) {
      vistePunti[p].classList[p === indice ? 'add' : 'remove']('affido__punto--attivo');
    }
  }

  /* Le lastre che la forma scelta lascia in vista (15 ottobre 2026). */
  function visibili(elenco) {
    return Array.prototype.filter.call(elenco, function (el) { return !el.hidden; });
  }

  function aggiornaContatore() {
    var viste = visibili(figure);
    if (!viste.length) return;
    var indice = Math.round(lastre.scrollLeft / (viste[0].offsetWidth || 1));
    indice = Math.max(0, Math.min(indice, viste.length - 1));
    segnaPosizione(indice);
  }

  /* Con Orecchini solo le foto degli orecchini, con Gemelli solo quelle dei gemelli. */
  function filtra(gruppo) {
    var tutti = [figure, punti, miniature];
    for (var e = 0; e < tutti.length; e++) {
      for (var f = 0; f < tutti[e].length; f++) {
        var g = tutti[e][f].getAttribute('data-gruppo');
        tutti[e][f].hidden = !!(g && gruppo && g !== gruppo);
      }
    }
    if (lastre) lastre.scrollTo({ left: 0 });
    var prima = visibili(figure)[0];
    if (prima) attiva(prima.getAttribute('data-galleria-lastra'));
  }

  document.addEventListener('change', function (evento) {
    var campo = evento.target;
    if (!campo || campo.type !== 'radio') return;
    if (campo.hasAttribute('data-affido-titolo')) filtra(campo.getAttribute('data-affido-titolo'));
    else if (campo.hasAttribute('data-affido-opzione')) filtra(String(campo.value).toLowerCase());
  });

  var sceltaIniziale = document.querySelector('[data-affido-titolo]:checked');
  if (sceltaIniziale && galleria.querySelector('[data-gruppo]')) filtra(sceltaIniziale.getAttribute('data-affido-titolo'));

  if (lastre) {
    lastre.addEventListener('scroll', function () {
      if (inAttesa) return;
      inAttesa = true;
      window.requestAnimationFrame(function () {
        inAttesa = false;
        aggiornaContatore();
      });
    }, { passive: true });
  }

  function attiva(n) {
    var scelta = String(n);
    for (var i = 0; i < figure.length; i++) {
      figure[i].classList[figure[i].getAttribute('data-galleria-lastra') === scelta ? 'add' : 'remove']('affido__lastra--attiva');
    }
    for (var m = 0; m < miniature.length; m++) {
      miniature[m].setAttribute('aria-pressed', miniature[m].getAttribute('data-galleria-vai') === scelta ? 'true' : 'false');
    }
    var viste = visibili(figure);
    for (var w = 0; w < viste.length; w++) {
      if (viste[w].getAttribute('data-galleria-lastra') === scelta) segnaPosizione(w);
    }
  }

  function suClick() {
    attiva(this.getAttribute('data-galleria-vai'));
  }

  function suTasto(evento) {
    var passo = 0;
    if (evento.key === 'ArrowRight' || evento.key === 'ArrowDown') passo = 1;
    else if (evento.key === 'ArrowLeft' || evento.key === 'ArrowUp') passo = -1;
    else if (evento.key === 'Home') passo = -miniature.length;
    else if (evento.key === 'End') passo = miniature.length;
    else return;
    evento.preventDefault();
    var viste = visibili(miniature);
    var indice = viste.indexOf(this) + passo;
    indice = Math.max(0, Math.min(indice, viste.length - 1));
    viste[indice].focus();
    attiva(viste[indice].getAttribute('data-galleria-vai'));
  }

  /* Le frecce del telefono: una foto avanti o indietro, a scatto. */
  var passi = galleria.querySelectorAll('[data-galleria-passo]');
  for (var q = 0; q < passi.length; q++) {
    passi[q].addEventListener('click', function () {
      if (!lastre) return;
      var largo = lastre.clientWidth || 1;
      var quante = visibili(figure).length;
      var ora = Math.round(lastre.scrollLeft / largo);
      var dopo = ora + Number(this.getAttribute('data-galleria-passo'));
      if (dopo < 0) dopo = quante - 1;
      if (dopo > quante - 1) dopo = 0;
      lastre.scrollTo({ left: dopo * largo, behavior: ridotto ? 'auto' : 'smooth' });
    });
  }

  for (var k = 0; k < miniature.length; k++) {
    miniature[k].addEventListener('click', suClick);
    miniature[k].addEventListener('keydown', suTasto);
  }

  var dialogo = document.querySelector('[data-lastra-dialogo]');
  if (!dialogo || typeof dialogo.showModal !== 'function') return;

  var immagine = dialogo.querySelector('[data-lastra-immagine]');
  var bottoneChiudi = dialogo.querySelector('[data-lastra-chiudi]');
  var daRimettere = null;
  var grande = window.matchMedia('(min-width: 64rem)');

  /* La lastra a piena finestra solo sullo schermo grande: sul telefono le foto
     sono già a tutta larghezza, e un trascinamento breve preso per un tocco
     apriva la lastra sulla prima foto, senza modo di passare alle altre. */
  function apri() {
    if (!grande.matches) return;
    if (immagine) {
      var larghezza = Number(this.getAttribute('data-lastra-larghezza'));
      var altezza = Number(this.getAttribute('data-lastra-altezza'));
      if (larghezza && altezza) {
        immagine.width = larghezza;
        immagine.height = altezza;
      }
      immagine.alt = this.getAttribute('data-lastra-alt') || '';
      immagine.src = this.getAttribute('data-lastra-src') || '';
    }
    daRimettere = this;
    dialogo.showModal();
    if (bottoneChiudi) bottoneChiudi.focus();
  }

  function chiudi() {
    if (dialogo.open) dialogo.close();
  }

  var apritori = galleria.querySelectorAll('[data-lastra]');
  for (var a = 0; a < apritori.length; a++) {
    apritori[a].addEventListener('click', apri);
  }

  dialogo.addEventListener('close', function () {
    if (daRimettere) daRimettere.focus();
    daRimettere = null;
  });

  dialogo.addEventListener('cancel', function (evento) {
    evento.preventDefault();
    chiudi();
  });

  if (bottoneChiudi) bottoneChiudi.addEventListener('click', chiudi);

  dialogo.addEventListener('click', function (evento) {
    if (evento.target !== immagine) chiudi();
  });

  /* Il fuoco gira dentro la lastra: dall'ultimo elemento torna al primo. */
  dialogo.addEventListener('keydown', function (evento) {
    if (evento.key !== 'Tab') return;
    var elenco = dialogo.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!elenco.length) return;
    var primo = elenco[0];
    var ultimo = elenco[elenco.length - 1];
    if (evento.shiftKey && (document.activeElement === primo || !dialogo.contains(document.activeElement))) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primo.focus();
    }
  });
})();
